import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithHandlingUnauthorized } from '@ui/src';

const api = createApi({
  reducerPath: 'authApi',
  baseQuery: baseQueryWithHandlingUnauthorized(process.env.API_HOST as string),
  tagTypes: ['Auth'],
  endpoints: () => ({}),
});

export default api;
